import { useId } from 'react';

const CustomDropdown = ({
  options,
  value,
  onChange,
  isOpen,
  onToggle,
  id,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
}) => {
  const generatedId = useId();
  const dropdownId = id || `custom-dropdown-${generatedId}`;
  const listboxId = `${dropdownId}-listbox`;
  
  return (
    <div className="relative w-full">
      {/* Trigger */}
      <div
        id={dropdownId}
        className={`w-full p-2 border rounded-md bg-white
          flex justify-between items-center cursor-pointer
          focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2
          ${isOpen ? 'border-blue-500 text-[#0C0D1A] text-base' : 'border-[#CBCDD6] text-[#CBCDD6]'}
        `}
        onClick={onToggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onToggle();
          } else if (e.key === 'Escape' && isOpen) {
            onToggle();
          }
        }}
        tabIndex={0}
        role="combobox"
        aria-expanded={isOpen}
        aria-controls={listboxId}
        aria-haspopup="listbox"
        // A <label htmlFor> can't name a div combobox, so callers name it with one of these
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
      >
        <span>{value || 'Product Select'}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21" height="20"
          viewBox="0 0 21 20"
          fill="none"
          className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        >
          <path
            d="M5.33337 7.5L10.3334 12.5L15.3334 7.5"
            stroke="#0C0D1A" strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Dropdown */}
      {isOpen && (
        <ul
          id={listboxId}
          className="absolute z-10 w-full mt-2 bg-white rounded-md shadow-lg border border-[#006EB7]"
          role="listbox"
        >
          {options.map((option, i) => (
            <li
              key={i}
              className="px-4 py-2 hover:bg-[#F3F4F8] focus:bg-[#F3F4F8] text-base text-[#0C0D1A] font-450 cursor-pointer flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-inset"
              onClick={() => {
                onChange(option);
                onToggle();
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onChange(option);
                  onToggle();
                }
              }}
              tabIndex={0}
              role="option"
              aria-selected={value === option}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
